module.exports = __webpack_public_path__ + "img/md-link.39fd3a56.svg";